import React from "react";
import CompanyContacts from "components/EditCompanyContacts/CompanyContacts";
import { useLoginContext } from "contexts/LoginContext/LoginContext";
import Title from "antd/lib/typography/Title";

const ContactPersons = () => {
  const { currentUser } = useLoginContext();
  if (!currentUser) return null;
  return (
    <>
      <Title level={2}>Mine kontaktpersoner</Title>
      <CompanyContacts companyId={currentUser.id} />
    </>
  );
};

export default ContactPersons;
